import PropTypes from 'prop-types';
import { useState } from 'react';

import { Dropdown, Form } from 'react-bootstrap';
import t from '../../../text';
import { useSubmitAndCloseDropdown } from '../../hooks/useSubmitAndCloseDropdown';
import { getShortDateFormat } from '../../utils/date';

import { useDispatch, useSelector } from 'react-redux';
import { selectDate, selectDuration } from '../../redux/search/form/actions';
import {
  getNightsAvailableSelector,
  isArrivalDateAvailableSelector,
  isDurationInvalidSelector,
  searchFormArrivalDateSelector,
  searchFormDurationSelector,
} from '../../redux/search/form/selectors';
import { SelectControl } from '../Common/SelectControl';
import { DatePicker } from './DatePicker';

export const DateDurationSelect = ({ textStyle = 'white' }) => {
  const dispatch = useDispatch();
  const { submitAndCloseDropdown } = useSubmitAndCloseDropdown();

  const duration = parseInt(useSelector(searchFormDurationSelector));
  const arrivalDate = useSelector(searchFormArrivalDateSelector);

  const nightsOptions = useSelector(getNightsAvailableSelector);
  const isDurationInvalid = useSelector(isDurationInvalidSelector);
  const isArrivalDateAvailable = useSelector(isArrivalDateAvailableSelector);
  const formIsInvalid = isDurationInvalid || !isArrivalDateAvailable;

  const onDurationChange = (e) => selectDuration(dispatch, parseInt(e.target.value));

  const [showDatePanel, setShowDatePanel] = useState(false);
  const handleDateToggle = () => setShowDatePanel(!showDatePanel);

  const handleDateChange = (date, modifiers, shouldCloseDropdown) => {
    if (modifiers.disabled) return;
    if (shouldCloseDropdown) {
      submitAndCloseDropdown(date, selectDate, setShowDatePanel);
    } else {
      selectDate(dispatch, date);
    }
  };

  return (
    <Form.Group controlId="searchbox-date-duration" className={formIsInvalid ? 'invalid-form' : ''}>
      <Form.Label className={`text-${textStyle}`}>{t('search.durationAndArrivalDate')}</Form.Label>
      <Dropdown show={showDatePanel} onToggle={handleDateToggle} drop="down">
        <Dropdown.Toggle as="button" type="button" className="toggle-popup is-calendar" role="button" tabIndex="0">
          <span>{getDateAndDurationText(arrivalDate, parseInt(duration))}</span>
        </Dropdown.Toggle>
        <Dropdown.Menu className="a-popup no-max-height searchbox-date-duration p-3">
          <h5>{t('search.stayingForHowLong')}</h5>
          <Form.Group controlId="searchbox-date-duration-nights" className="mb-3">
            <SelectControl>
              <Form.Control as="select" value={duration} onChange={onDurationChange}>
                {isDurationInvalid && duration && (
                  <option value={duration} disabled>
                    {t('search.xNightsUnavailable', duration)}
                  </option>
                )}
                {nightsOptions?.map((val) => (
                  <option key={val} value={val}>
                    {t('search.xNights', val)}
                  </option>
                ))}
              </Form.Control>
            </SelectControl>
          </Form.Group>
          <h5>{t('search.selectAnArrivalDate')}</h5>
          <DatePicker handleDateChange={handleDateChange} />
        </Dropdown.Menu>
      </Dropdown>
    </Form.Group>
  );
};

DateDurationSelect.propTypes = {
  textStyle: PropTypes.string,
};

const getDateAndDurationText = (arrivalDate, duration) => {
  if (arrivalDate && duration) {
    return t('search.dateNights', getShortDateFormat(new Date(arrivalDate)), duration);
  } else {
    return t('search.selectADate');
  }
};
